<template>
    <InlineError v-if="form.errors.files" :message="form.errors.files"/>

    <div class="overflow-y-scroll mb-12" :class="{ 'aspect-w-1 aspect-h-1 md:aspect-w-16 md:aspect-h-6': !progress && form.files.length == 0 }">
        <div class="flex flex-wrap items-center justify-center border-2 transition-colors duration-100 ease-out border-dashed w-full rounded-xl" :class="{ 'border-regal-blue-700 bg-regal-blue-100 p-6': dragActive, 'border-gray-500 hover:border-gray-600 p-6': !dragActive && !form.files.length, 'border-transparent': form.files.length }"
            @dragenter.prevent="toggleDragActive"
            @dragleave.prevent="toggleDragActive"
            @dragover.prevent
            @drop.prevent="drop"
        >

            <div v-if="dragActive" class="pointer-events-none w-full flex flex-col space-y-3 items-center justify-center text-regal-blue-700">
                <svg class="w-8 h-8 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"></path></svg>
                <div class="text-lg font-medium">
                    Drop files here
                </div>
            </div>

            <div v-if="!progress && !form.files.length && !dragActive" class="text-center space-y-4">
                <div class="w-full flex flex-col items-center justify-center cursor-pointer" @click="$refs.audio.click()">
                    <div class="inline-flex space-x-3 font-bold text-regal-blue-700 border border-regal-blue-700 rounded-full py-3 px-6 hover:bg-regal-blue-700 hover:text-white transition-colors duration-100 ease-in">
                        <div class="">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
                        </div>
                        <div class="">
                            Upload audio files
                        </div>
                    </div>
                    <div class="text-xs max-w-md mt-3 text-gray-700">
                        Files must be of type: {{ this.fileTypes.join(', ') }}
                    </div>
                </div>
            </div>

            <div v-if="progress" class="w-full flex space-x-1.5 p-8 items-center justify-center">
                <div class="">
                    <svg class="animate-spin h-5 w-5 mr-1 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <div class="font-medium text-gray-700">
                    Uploading …
                </div>
            </div>

            <div v-if="form.files.length" class="w-full">
                <div class="grid grid-cols-3 w-full gap-4">
                    <div v-for="file in form.files" class="flex flex-col items-center justify-center bg-gray-200 rounded-xl p-4">
                        <div class="w-full">
                            <div class="aspect-w-1 aspect-h-1">
                                <div class="w-full h-full flex items-center justify-center">
                                    <svg class="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-between items-center space-x-1.5">
                            <div class="flex-1">
                                <div class="w-full line-clamp-1 font-medium">
                                    {{ file.name }}
                                </div>
                                <div class="w-full line-clamp-1 text-sm">
                                    {{ file.size }} MB
                                </div>
                            </div>
                            <div class="shrink-0 text-gray-700 hover:text-red-500 cursor-pointer" @click="deleteFile(file)">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="">

    </div>
    <div class="w-full flex flex-wrap justify-between items-center self-end pt-4">
        <div @click="$emit('back')">
            <Button label="Back" type="secondary"/>
        </div>
        <div @click="store">
            <Button :label="'Confirm (' + configuration.price + ')'" />
        </div>
    </div>
    <input type="file" accept="audio/*" ref="audio" class="hidden" @input="upload" multiple/>

</template>

<script>
    import { ref } from 'vue'
    import Modal from '@/Shared/Modal'
    import InlineError from '@/Shared/InlineError'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Button from '@/Shared/Button'


export default {
    setup(props) {
        const progress = ref(null)
        const dragActive = ref(false)
        const previewAvailable = ref(false)
        // const open = ref(false)
        const toggleDragActive = () => {
            dragActive.value = !dragActive.value
        }

        const form = useForm({
            files: [],
            terms: false,
            configuration: props.configuration,
        })

        return {
            progress,
            dragActive,
            toggleDragActive,
            open,
            previewAvailable,
            form,
        }
    },
    components: { Modal, InlineError, Button },
    emits: ['submit', 'back', 'update:open'],
    props: [ 'configuration', 'open', 'fileTypes' ],
    methods: {
        drop(e) {
            this.toggleDragActive()
            this.upload(e.dataTransfer.files)

        },
        validateFiles(files) {
            this.form.errors.audio = null
            Array.from(files).forEach(file => {
                console.log(file.size);
                if (file.size > 1000000000) {
                    return this.form.errors.files = 'The file “' + file.name + '” is too large. Max. 1GB per file allowed.'
                }
            })
            // if (files.length) {
            //     file = file[0]
            // }
            // if (!this.supportedAudioFileTypes.includes(file.type)) {
            //     return this.form.errors.audio = 'Please select a file of the following types: ' + this.supportedAudioFileTypes.join(', ')
            // }
            return null
        },
        deleteFile(file) {
            const index = this.form.files.indexOf(file)
            if (index > -1) {
                this.form.files.splice(index, 1)
            }
        },
        store() {
            this.form.post(route('episodes.upload'), {
                onSuccess: () => {
                    this.open = false
                    this.form.reset()
                    this.$emit('update:open', false)
                }
            })
        },
        upload(e) {
            let files = !e.target ? e : this.$refs.audio.files
            this.validateFiles(files)
            if (this.form.errors.files) {
                return false
            }
            // if (file.length) {
            //     file = file[0]
            // }

            Array.from(files).forEach(file => {
                Vapor.store(file, {
                    progress: progress => {
                        this.progress = Math.round(progress * 100)
                    }
                }).then(response => {
                    this.form.files.push({
                        name: file.name,
                        content_type: file.type,
                        extension: file.name.split('.').pop() ?? null,
                        lastModifiedDate: file.lastModifiedDate,
                        uuid: response.uuid,
                        key: response.key,
                        bucket: response.bucket,
                        size: Math.floor((file.size/1000000) * 100) / 100
                    })
                    this.progress = null
                })
            })
            this.$refs.audio.value = null;
        }
    },
}
</script>
